import React, { useContext, useMemo } from "react";
import { AuthManagerContext } from "../../contexts/AuthManager";
import { StyleSheet } from "react-native";
import { useTheme } from "../../hooks/use-theme";
import { useIntercom } from "../../hooks/intercom";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { GestureDetector, Gesture } from "react-native-gesture-handler";

export const IntercomButton = () => {
    const { user } = useContext(AuthManagerContext);
    const styles = useStyles();
    const { presentIntercom } = useIntercom();
    const isHover = useSharedValue<boolean>(false);
    const animatedStyle = useAnimatedStyle(() => {
        return {
            transform: [
                {
                    scale: withTiming(isHover.value ? 1.2 : 1),
                },
            ],
        };
    });
    const hover = Gesture.Hover();
    hover
        .activeCursor("pointer")
        .onBegin(() => {
            isHover.value = true;
        })
        .onFinalize(() => {
            isHover.value = false;
        });

    const tap = Gesture.Tap();
    tap.onTouchesUp(() => {
        void presentIntercom();
    });
    const composed = Gesture.Race(hover, tap);

    if (user) {
        // we are logged in, we have access to the help in the tabs
        return null;
    }
    return (
        <GestureDetector gesture={composed}>
            <Animated.View style={[styles.button, animatedStyle]}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 28 32"
                    fill="white"
                    height="24px"
                    width="24px"
                >
                    <path d="M28 32s-4.714-1.855-8.527-3.34H3.437C1.54 28.66 0 27.026 0 25.013V3.644C0 1.633 1.54 0 3.437 0h21.125c1.898 0 3.437 1.632 3.437 3.645v18.404H28V32zm-4.139-11.982a.88.88 0 00-1.292-.105c-.03.026-3.015 2.681-8.57 2.681-5.486 0-8.517-2.636-8.571-2.684a.88.88 0 00-1.29.107 1.01 1.01 0 00-.219.708.992.992 0 00.318.664c.142.128 3.537 3.15 9.762 3.15 6.226 0 9.621-3.022 9.763-3.15a.992.992 0 00.317-.664 1.01 1.01 0 00-.218-.707z"></path>
                </svg>
            </Animated.View>
        </GestureDetector>
    );
};

const useStyles = () => {
    const { gridSize } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                button: {
                    position: "absolute",
                    zIndex: 100,
                    bottom: gridSize / 2,
                    right: gridSize / 2,
                    height: 48,
                    width: 48,
                    backgroundColor: "blue",
                    color: "white",
                    borderRadius: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    alignContent: "center",
                    borderColor: "rgba(255,255,255,0.33)",
                    borderWidth: 1,
                },
                pressable: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    alignContent: "center",
                },
            }),
        [gridSize],
    );
};
